import { useEffect, useState } from 'react';

const useWindowWidth = () => {
  const [width, setWidth] = useState(() => 
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (width > 1500) return 6;
  if (width > 1200) return 5;
  if (width > 1000) return 4;
  if (width > 768) return 3;
  return 2;
};

export default useWindowWidth;
